export function LightBorder({ w, h, className }: { w?: number | string; h?: number | string; className?: string }) {
  return (
    <svg width={w} height={h} viewBox="0 0 145 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g filter="url(#filter0_d_9157_64508)">
        <path
          d="M128.5 14H16C13.7909 14 12 12.2091 12 10V8H8V10C8 14.4183 11.5817 18 16 18H128.5C132.918 18 136.5 14.4183 136.5 10V8H132.5V10C132.5 12.2091 130.709 14 128.5 14Z"
          fill="#FF46AA"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9157_64508"
          x="0"
          y="0"
          width="144.5"
          height="26"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.27451 0 0 0 0 0.666667 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9157_64508" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9157_64508" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}
